import { render, staticRenderFns } from "./usedCarSourceSwitchManagement.vue?vue&type=template&id=420b7db4&scoped=true"
import script from "./usedCarSourceSwitchManagement.vue?vue&type=script&lang=js"
export * from "./usedCarSourceSwitchManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b7db4",
  null
  
)

export default component.exports